import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, pipe, of, BehaviorSubject } from 'rxjs';
import { ApiRoutes } from 'src/app/config/api-routes';
import { tap, catchError, map } from 'rxjs/operators';
import { Login } from '../model/login';

@Injectable()
export class LoginsService {
  public updated$: Subject<any> = new Subject<any>();
  public loginsCache$: BehaviorSubject<Login[]> = new BehaviorSubject<Login[]>([]);

  constructor(
    private httpClient: HttpClient,
    private config: ApiRoutes,
  ) { }

  public getLogins(): Observable<Login[]> {
    return this.httpClient
      .get<Login[]>(this.config.LOGIN)
      .pipe(catchError(() => of([])));
  }

  public getLogin(id: string): Observable<Login> {
    return this.httpClient.get<Login>(this.config.getRouteWithInjectedParams(this.config.LOGIN_DETAILS, [id]));
  }

  public updateLogin(login: Login) {
    return this.httpClient.put(this.config.LOGIN, login)
      .pipe(
        tap(() => this.updated$.next(null)),
      );
  }

  public reloadCacheIfLoginIdNotFound(loginIds: number[]) {
    const cachedLoginIds = this.loginsCache$.value.map(x => x.id);

    if (loginIds.some(loginId => !cachedLoginIds.includes(loginId))) {
      this.getLogins()
        .subscribe(logins => this.loginsCache$.next(logins));
    }
  }
}
